mutation DeleteChatMessage($id: ID!) {
  deleteChatMessage(id: $id) {
    id
  }
}
